import React from "react";
import { Helmet } from "react-helmet-async";
import MarketingLayout from "../../marketing/components/MarketingLayout";

const PolitiqueConfidentialite = () => (
  <MarketingLayout showFinalCta={false}>
    <Helmet>
      <title>Politique de confidentialité - ASAP Hub</title>
      <meta name="description" content="Politique de confidentialité ASAP Hub : collecte, traitement et protection des données personnelles, conformité RGPD." />
      <link rel="canonical" href="https://www.asap-hub.ai/resource/Politique" />
    </Helmet>

    <header className="mk-legal-hero">
      <div className="mk-wrap">
        <span className="mk-eyebrow">
          <span className="mk-pulse" aria-hidden="true" />
          RGPD &amp; confidentialité
        </span>
        <h1>Politique de confidentialité</h1>
        <p className="mk-lead">
          Comment ASAP Hub collecte, traite et protège les données personnelles des candidats et des entreprises clientes.
        </p>
      </div>
    </header>

    <section className="mk-legal-body">
      <div className="mk-wrap">
        <div className="mk-legal-card mk-reveal">
          <h2>1. Objectif de la politique de confidentialité</h2>
          <p>
            La présente politique de confidentialité a pour objet d'informer les utilisateurs du site internet <strong>www.asap-hub.ai</strong> (ci-après le « Site ») sur la collecte, le traitement et la protection des données à caractère personnel effectués par la société ASAP Hub et ses filiales (ci-après la « Société »).
          </p>
          <p>
            Dans le cadre de l'utilisation du Site, la Société collecte et traite les données personnelles des individus sollicitant des opportunités d'emploi ou de missions, désignés ci-après le(s) « Candidat(s) ».
          </p>
          <p>
            Les entités payant pour l'accès et l'utilisation de la solution, notamment les sociétés de conseil, cabinets de recrutement et autres prestataires de services, sont désignées ci-après les « Entreprises ».
          </p>

          <hr className="mk-legal-divider" />

          <h2>2. Responsable du traitement des données</h2>
          <p>
            ASAP Hub, société par actions simplifiée immatriculée au Registre du Commerce et des Sociétés (RCS) de Paris sous le numéro 93205471100019, dont le siège social est situé 231 Rue Saint-Honoré 75001 Paris, en tant qu'éditeur de Asap-CV, agit en qualité de Responsable de traitement s'agissant des traitements de vos Données à caractère personnel mis en œuvre dans le cadre des services qui vous sont fournis.
          </p>
          <p>
            Ahmed SADOUN est le délégué à la protection des données (DPO) joignable à l'adresse mail suivante : <a href="mailto:sadoun.ahmed@asap-hub.ai">sadoun.ahmed@asap-hub.ai</a>
          </p>

          <hr className="mk-legal-divider" />

          <h2>3. Types de données collectées</h2>
          <p>
            Notre capacité à garantir la meilleure rédaction du CV du Candidat en vue de missions auprès de nos Entreprises nécessite l'accès à certaines données à caractère personnel concernant le Candidat, telles que des informations relatives à son profil et à son identité. À cet effet, nous collectons les données personnelles suivantes :
          </p>
          <ul>
            <li>Données d'identification : nom, prénom, âge</li>
            <li>Coordonnées : adresse e-mail, numéro de téléphone, URL LinkedIn, adresse postale, code postal, ville, région, pays</li>
            <li>Informations professionnelles : profession, niveau de séniorité, compétences, langues maîtrisées et niveau de maîtrise</li>
            <li>Historique professionnel : nom des employeurs, dates de début et de fin de contrat pour chaque expérience professionnelle</li>
            <li>Parcours académique : nom des écoles et/ou universités fréquentées, niveau d'études, diplômes obtenus et dates d'obtention</li>
            <li>Compétences techniques : technologies maîtrisées, nombre d'années d'expérience, références professionnelles et projets réalisés</li>
          </ul>
          <p>Ces données sont essentielles pour garantir la qualité et l'efficacité des services que nous offrons.</p>

          <hr className="mk-legal-divider" />

          <h2>4. Méthodes de collecte des données</h2>
          <p>
            Nous collectons les Données à caractère personnel des candidats lors de la saisie du formulaire en ligne et du dépôt de CV au format PDF ou Word que le candidat a lui-même fourni.
          </p>
          <p>Nous ne les traitons qu'en vue de répondre à vos sollicitations et de fournir nos services.</p>

          <hr className="mk-legal-divider" />

          <h2>5. Finalités du traitement des données</h2>
          <p>Nous traitons les Données à caractère personnel des candidats pour les finalités suivantes :</p>
          <ul>
            <li>Diffusion du dossier de compétences du candidat vers uniquement le client concerné par le biais d'un email</li>
            <li>Analyse, réécriture et complétion des descriptions des expériences professionnelles via le service sous-traitant d'intelligence artificielle</li>
            <li>Reformatage des fichiers via une API sous-traitante pour la conversion des fichiers dans un format initial vers un format final</li>
          </ul>

          <hr className="mk-legal-divider" />

          <h2>6. Base légale du traitement des données</h2>
          <p>
            Les traitements mis en œuvre au titre de la présente politique de confidentialité ont pour base légale l'exécution des Conditions Générales d'Utilisation (CGU), que le candidat a acceptées au moment de la soumission de son CV.
          </p>
          <p>
            Par exception, les traitements relatifs à la réalisation de rapports statistiques anonymisés ont pour base légale l'intérêt légitime de notre société et des entreprises.
          </p>
          <p>
            Nous veillons à protéger vos droits et libertés en anonymisant vos Données à caractère personnel avant de produire ces rapports, rendant impossible votre ré-identification.
          </p>

          <hr className="mk-legal-divider" />

          <h2>7. Durée de conservation des données</h2>
          <p>Nous avons modifié notre politique de gestion des données et nous ne stockons plus aucune donnée après leur traitement initial.</p>
          <p>Toutes les données soumises via notre plateforme sont lues dans le cadre de l'utilisation du service, puis immédiatement supprimées une fois le traitement terminé.</p>
          <p>
            Cela signifie que, dès que le CV ou les informations sont traitées et envoyées aux entreprises, toutes les traces de données personnelles sont supprimées de nos systèmes de manière définitive. Aucune donnée personnelle n'est conservée sur nos serveurs au-delà de la phase de traitement.
          </p>

          <hr className="mk-legal-divider" />

          <h2>8. Partage des données avec des tiers et sous-traitance</h2>
          <p>Nous ne stockons ni ne conservons aucune donnée à caractère personnel.</p>
          <p>Par conséquent, aucune donnée personnelle n'est partagée avec des tiers, que ce soit des prestataires de services, recruteurs, ou autres entités externes.</p>
          <p>Dans le cadre de notre activité, nous faisons appel à certains services tiers pour le traitement temporaire des données.</p>
          <p>
            Ces services incluent des solutions d'intelligence artificielle, d'analyse et de traitement des données fournies par des entreprises situées en Europe et aux États-Unis. Les données transmises ne sont ni conservées (utilisation du mode de non-rétention) ni utilisées pour entraîner leurs modèles (LLM).
          </p>
          <p>
            Les services que nous utilisons respectent les normes de protection des données en vigueur et sont soumis à des obligations contractuelles de sécurité et de confidentialité. Ces services sont conformes aux exigences légales, y compris le RGPD, pour garantir la protection de vos données personnelles.
          </p>
          <p>Tous les sous-traitants sont conformes aux clauses contractuelles types (CCT) ou autres mécanismes de protection des données.</p>

          <hr className="mk-legal-divider" />

          <h2>9. Sécurité des données</h2>
          <p>
            Nous mettons en œuvre les mesures techniques et organisationnelles de sécurité que nous estimons appropriées pour préserver la confidentialité et la sécurité de vos Données à caractère personnel et lutter contre leur destruction, perte, altération ou divulgation non autorisées.
          </p>
          <p>
            Conformément à nos obligations en vertu de la Réglementation applicable, les mesures que nous avons implémentées sont proportionnées aux risques que nous avons identifiés comme étant susceptibles d'affecter vos Données.
          </p>
          <p>Parmi ces mesures figurent notamment :</p>
          <ul>
            <li>La gestion des habilitations et des restrictions des droits d'accès aux données</li>
            <li>Le recours à des procédés d'identification sécurisés</li>
            <li>La mise en œuvre de mesures de sauvegarde</li>
            <li>La mise en œuvre de mesures de chiffrement et de cryptage (clés privées)</li>
            <li>La mise en œuvre de mesures de traçabilité</li>
          </ul>
          <p>Nous réalisons des audits réguliers de ces mesures pour garantir leur efficacité continue.</p>
          <p>
            Lorsque nous recourons à des prestataires à qui nous avons délégué tout ou partie d'un Traitement et qui traitent vos Données à caractère personnel conformément à nos instructions, nous nous engageons à leur imposer contractuellement des garanties de sécurité analogues à celles que nous mettons en œuvre pour protéger vos Données à caractère personnel et nous réservons le droit de procéder à un audit auprès d'eux afin de nous assurer du respect de leurs obligations.
          </p>
          <p>
            En cas de violation de données, nous nous engageons à notifier la CNIL, les candidats et nos entreprises dans les conditions prescrites par le RGPD et, si ladite violation fait peser un risque élevé sur le candidat ou l'entreprise, à en aviser et à communiquer le cas échéant les informations et recommandations nécessaires.
          </p>

          <hr className="mk-legal-divider" />

          <h2>10. Droits des utilisateurs</h2>
          <h3>A. Énoncé de vos droits</h3>
          <p>Conformément à la Réglementation applicable, vous disposez des droits suivants :</p>
          <ul>
            <li>Un droit de nous demander confirmation que des données les concernant sont traitées, d'obtenir des informations sur les caractéristiques de ces Traitements, d'accéder à ces données et de nous en demander une copie (droit d'accès et de copie)</li>
            <li>Un droit de faire rectifier ou de compléter toute donnée vous concernant qui serait erronée ou obsolète (droit de rectification)</li>
            <li>Un droit de retirer votre consentement à tout moment à la condition que le Traitement concerné soit exclusivement fondé sur cette base légale</li>
            <li>Un droit de vous opposer au Traitement de vos Données à caractère personnel pour des raisons tenant à votre situation particulière et d'obtenir leur effacement, auquel cas nous ferons droit à cette demande sauf si le Traitement est justifié par des motifs légitimes et impérieux (droit d'opposition pour motif légitime et droit à l'effacement)</li>
            <li>Un droit de supprimer votre compte à tout moment ce qui impliquera la suppression des Données y étant associées</li>
            <li>Un droit d'obtenir la limitation du Traitement temporairement en cas de demande de rectification ou d'opposition pour motif légitime le temps que nous analysions votre demande, ce qui signifie en pratique que les Données à caractère personnel sont conservées, mais que nous ne pouvons pas les traiter (droit à la limitation)</li>
            <li>Un droit à la portabilité de Données, c'est-à-dire un droit d'obtenir de notre part la restitution des Données à caractère personnel que vous nous avez communiquées dans un format d'usage courant dès lors que le Traitement est automatisé et fondé sur le consentement ou sur l'exécution d'un contrat</li>
            <li>Un droit de formuler des directives relatives au Traitement de vos données après votre décès et de nous demander de conserver, effacer ou communiquer vos données à un tiers expressément désigné, étant précisé que dès lors que nous avons connaissance de votre décès et à défaut d'instructions de votre part, nous nous engageons à détruire vos Données à caractère personnel, sauf si leur conservation s'avère nécessaire à des fins probatoires ou pour répondre à une obligation légale (droit post mortem)</li>
            <li>Les utilisateurs peuvent contacter la CNIL s'ils considèrent que leurs droits ne sont pas respectés</li>
          </ul>

          <h3>B. Modalités d'exercice de vos droits</h3>
          <p>
            Lorsque vous souhaitez exercer l'un des droits précités, vous pouvez nous contacter par courrier à l'adresse suivante : Société Asap Hub, 231 Rue Saint-Honoré, 75001 Paris ou par email à l'adresse suivante : <a href="mailto:hello@asap-cv.fr">hello@asap-cv.fr</a>
          </p>
          <p>
            La demande d'exercice de droits doit émaner de vous exclusivement (sauf mandat donné à un tiers en bonne et due forme) et être la plus claire et exhaustive possible afin de nous permettre d'y répondre dans les meilleurs délais, compris entre un et trois mois selon son niveau de complexité.
          </p>
          <p>
            Nous pouvons éventuellement vous demander de compléter votre demande si elle n'est pas suffisamment précise, que le droit que vous souhaitez exercer n'est pas facilement identifiable ou que nous ne parvenons pas à établir votre identité, auquel cas nous pouvons être amenés à vous demander de fournir des informations complémentaires et notamment un justificatif d'identité, qui serait supprimé une fois votre identité vérifiée.
          </p>
          <p>
            En outre, nous ne serons pas tenus de répondre à votre demande si elle présente un caractère manifestement infondé ou excessif, et notamment si vous formulez des demandes répétitives qui auraient pour objet ou pour effet de déstabiliser nos activités.
          </p>

          <hr className="mk-legal-divider" />

          <h2>11. Modification de la politique de confidentialité</h2>
          <p>
            Nous nous réservons le droit de modifier, compléter ou mettre à jour la présente politique à tout moment pour tenir compte des évolutions légales, réglementaires et jurisprudentielles, ou des modifications des caractéristiques des traitements.
          </p>
          <p>Toute nouvelle version de la présente politique sera portée à votre connaissance par tout moyen de notre choix.</p>
          <p>Les entreprises et les candidats seront informés de toute mise à jour par email ou par notification sur le site, afin de respecter le principe de transparence continue.</p>

          <hr className="mk-legal-divider" />

          <h2>12. Contact</h2>
          <p>
            Vous pouvez nous adresser toute question ou réclamation relative à la présente politique ou nous faire part de recommandations ou de commentaires relatifs à cette dernière à l'adresse suivante : Société Asap Hub, 231 Rue Saint-Honoré, 75001 Paris ou par email à l'adresse suivante : <a href="mailto:hello@asap-cv.fr">hello@asap-cv.fr</a>
          </p>
        </div>
      </div>
    </section>
  </MarketingLayout>
);

export default PolitiqueConfidentialite;
